<template>
  <section class="business-matrix">
    <div class="business-matrix__body">
      <div class="business-matrix__lead">
        <div class="business-matrix__top">
          <span class="business-matrix__label">{{ data.label }}</span>
          <h2 class="business-matrix__title">{{ data.title }}</h2>
        </div>
        <p class="business-matrix__desc">{{ data.description }}</p>
      </div>
      <div class="business-matrix__cards">
        <div class="business-matrix__row">
          <div
            v-for="(card, index) in data.cards.slice(0, 2)"
            :key="index"
            class="business-matrix__card"
          >
            <div class="business-matrix__card-img">
              <img :src="card.image" :alt="card.title" />
            </div>
            <div class="business-matrix__card-content">
              <div class="business-matrix__card-text">
                <h3 class="business-matrix__card-title">{{ card.title }}</h3>
                <p class="business-matrix__card-copy">{{ card.description }}</p>
              </div>
              <button
                class="business-matrix__cta"
                @click="$emit('navigate', card.route)"
              >
                <span>了解更多</span>
                <span
                  class="material-symbols-rounded iconfont icon-youbian"
                ></span>
              </button>
            </div>
          </div>
        </div>
        <div class="business-matrix__row">
          <div
            v-for="(card, index) in data.cards.slice(2, 4)"
            :key="index + 2"
            class="business-matrix__card"
          >
            <div class="business-matrix__card-img">
              <img :src="card.image" :alt="card.title" />
            </div>
            <div class="business-matrix__card-content">
              <div class="business-matrix__card-text">
                <h3 class="business-matrix__card-title">{{ card.title }}</h3>
                <p class="business-matrix__card-copy">{{ card.description }}</p>
              </div>
              <button
                class="business-matrix__cta"
                @click="$emit('navigate', card.route)"
              >
                <span>了解更多</span>
                <span
                  class="material-symbols-rounded iconfont icon-youbian"
                ></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "BusinessMatrix",
  props: {
    data: {
      type: Object,
      default: () => ({
        label: "",
        title: "",
        description: "",
        cards: [],
      }),
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.business-matrix {
  @include theme-variable(bg-dark-blue);
  padding: $section-padding-pc;
  background-color: #194670ff;

  &__body {
    display: flex;
    gap: 22px;
  }

  &__lead {
    width: 430px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 76px;
  }

  &__top {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__label {
    font-family: $font-family;
    font-size: $font-size-label;
    font-weight: normal;
    letter-spacing: 1.5px;
    // @include theme-variable(text-label-gold, color);
    color: #d8c08e;
    text-align: left;
  }

  &__title {
    font-family: $font-family;
    font-size: 50px;
    font-weight: 700;
    @include theme-variable(text-light, color);
    margin: 0;
    text-align: left;
    color: #ffffff;
  }

  &__desc {
    font-family: $font-family;
    font-size: $font-size-body;
    font-weight: normal;
    line-height: 1.74;
    @include theme-variable(text-light-secondary, color);
    margin: 0;
    color: #ffffffb8;
    text-align: left;
  }

  &__cards {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 22px;
  }

  &__row {
    display: flex;
    gap: 22px;
  }

  &__card {
    flex: 1;
    border-radius: 16px;
    background: #f6f2ea;
    padding: 22px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    overflow: hidden;

    &:nth-child(2) {
      background: #d7e3ef;
    }
  }

  &__card-img {
    border-radius: 12px;
    height: 180px;
    overflow: hidden;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &::after {
      content: "";
      position: absolute;
      inset: 0;
      background: linear-gradient(
        145deg,
        rgba(16, 42, 67, 0.22),
        rgba(214, 184, 122, 0.22)
      );
    }
  }

  &__card-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 18px;
  }

  &__card-text {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  &__card-title {
    font-family: $font-family;
    font-size: 30px;
    font-weight: 700;
    @include theme-variable(text-title, color);
    margin: 0;
    text-align: left;
  }

  &__card-copy {
    font-family: $font-family;
    font-size: 14px;
    font-weight: normal;
    line-height: 1.72;
    @include theme-variable(text-secondary, color);
    text-align: left;
    margin: 0;
  }

  &__cta {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 44px;
    padding: 0 16px;
    border-radius: 16px;
    background: #fff9f1;
    border: 1px solid #c6a96b;
    font-family: $font-family;
    font-size: $font-size-nav;
    font-weight: 500;
    color: #0e2746;
    cursor: pointer;
    transition: background 0.2s;
    align-self: flex-start;

    .material-symbols-rounded {
      font-size: 18px;
    }

    &:hover {
      background: #fff3e6;
    }
  }

  @include tablet {
    padding: 40px 32px;

    &__body {
      flex-direction: column;
    }

    &__lead {
      width: 100%;
      gap: 32px;
    }

    &__title {
      font-size: 36px;
    }
  }

  @include mobile {
    padding: $section-padding-app;

    &__body {
      flex-direction: column;
    }

    &__lead {
      width: 100%;
      gap: 24px;
    }

    &__title {
      font-size: 30px;
    }

    &__row {
      flex-direction: column;
    }

    &__card-img {
      height: 140px;
    }
  }
}
</style>
